import React, { useState, useContext } from 'react'
import { giphyLightGrey } from '@giphy/js-brand'
import styled from 'styled-components'
import TabNavigation from '../../../../navigation-tabs'
import Details from './details'
import { CreationCaptureInfoContext } from './manager'
import Metadata from './metadata'
import Watermark from './watermark'
import Font from './custom-font'

const SECTIONS = {
    default: [
        {
            title: 'Capture Details',
            Component: Details,
        },
        {
            title: 'Metadata',
            Component: Metadata,
        },
    ],
    watermark: [
        {
            title: 'Watermark',
            Component: Watermark,
        },
    ],
    font: [
        {
            title: 'Custom Font',
            Component: Font,
        },
    ],
}

const Container = styled.div`
    color: ${giphyLightGrey};
`

type Props = {
    className?: string
}

const CreationCaptureInfoSections = ({ className }: Props) => {
    const [activeSectionIndex, setActiveSectionIndex] = useState<number>(0)
    const { isWatermarkOpen, isCustomFontOpen } = useContext(CreationCaptureInfoContext)

    const Section = isWatermarkOpen
        ? SECTIONS.watermark[0].Component
        : isCustomFontOpen
        ? SECTIONS.font[0].Component
        : SECTIONS.default[activeSectionIndex].Component
    const labels = isWatermarkOpen
        ? SECTIONS.watermark.map(section => section.title)
        : isCustomFontOpen
        ? SECTIONS.font.map(section => section.title)
        : SECTIONS.default.map(section => section.title)

    return (
        <Container className={className}>
            <TabNavigation labels={labels} onChange={setActiveSectionIndex} />
            <Section />
        </Container>
    )
}

export default CreationCaptureInfoSections
